import { Component } from '@angular/core';
import { NavController,LoadingController,ToastController,AlertController } from 'ionic-angular';
import * as firebase from 'firebase/app';
import * as moment from 'moment';
import '../../../node_modules/moment/locale/es';
import {CancellatePage} from './cancellate';
import { Params } from '../params';
import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';


@Component({
  selector: 'page-cancellations',
  templateUrl: 'list.html'
})
export class CancellationsPage{
  reasons = {
    "PE" : "Personal",
    "VA" : "Vacaciones",
    "FE" : "Festivo",
    "NP" : "No Pago"
  };
  years = [];
  customers = {};
  accounts = {};
  items;
  cancellations = [];
  //status: FirebaseObjectObservable<any>;
  month;
  year;
  loading;
  statuses;
  constructor(
    private nav: NavController,
    private loadingCtrl: LoadingController,
    public toastCtrl: ToastController,
    public alertCtrl: AlertController,
  ){
    this.statuses = {
      0 : "Vigente",
      1 : "Anulada"
    }
    let actual_year = Number(moment().format("YYYY"));
    let first_year = 2017;
    let end = (actual_year-first_year)+2;
    for(let y=0;y<end;y++){
      this.years.push(first_year+y);
    }

    this.month = moment().format("MM");
    this.year = actual_year;

    firebase.database().ref('/accounts').once('value').then((snap1)=> {
      this.accounts = snap1.val();
      firebase.database().ref('/customers').once('value').then((snap2)=> {
        this.customers = snap2.val();
        this.filter();
      });
    });
  }

  initializeItems() {
    this.items = this.cancellations;
  }

  getItems(ev: any) {
    this.initializeItems();
    let val = ev.target.value;
    if (val && val.trim() != '') {
      this.items = this.items.filter((item) => {
        return (item.customer.toLowerCase().indexOf(val.toLowerCase()) > -1);
      })
    }
  }

  exportxls(){
    /* generate worksheet */
    const ws: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(this.cancellations);

    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    /* save to file */
    const wbout: string = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    FileSaver.saveAs(new Blob([wbout]), 'SheetJS.xlsx');
  }

  filter(){
      let loading = this.loadingCtrl.create({
        content: 'Buscando suspensiones...'
      });
      loading.present();
      let first_date = this.year+"-"+this.month+"-01";
      let last_day = Number(moment(first_date).endOf('month').format('DD'));
      let canc = [];
      let total = 0;
      for(let d=1;d<=last_day;d++){
        let day = Params.number_two_digits(d);
        let date = this.year+this.month+day;
        firebase.database().ref('/cancellations/'+date).once('value').then((snap1)=> {
          total++;
          if(snap1.exists()){
            let anulations = snap1.val();
            let arr = Object.keys(snap1.val());
            for(let a=0;a<arr.length;a++){
              let obj = anulations[arr[a]];

              obj["origindata"] = Object.assign({}, anulations[arr[a]]);
              obj["customer"] = this.customers[arr[a]].name.trim()+" "+this.customers[arr[a]].lastname.trim();
              obj["customercode"] = arr[a];
              obj["owner"] = this.accounts[anulations[arr[a]].owner] ? this.accounts[anulations[arr[a]].owner].name : '';
              obj["date"] =  moment(this.year+"-"+this.month+"-"+day).format("dddd DD");
              obj["dateformat"] =  this.year+this.month+day;
              try{
                obj["nullby"] =  (anulations[arr[a]].nullby!=undefined) ? this.accounts[anulations[arr[a]].nullby].name : "";
              } catch(e){
                console.log(obj, this.accounts);
                obj["nullby"] =  '';
              }
              canc.push(obj);
            }
          }
          if(total==last_day){
            loading.dismiss();
            this.cancellations = canc;
            this.initializeItems();
            console.log(canc);
          }
        });
      }
  }

  nullCancelation(c){
    let confirm = this.alertCtrl.create({
      title: 'Anular suspensión',
      message: '¿Está seguro de anular la suspensión de '+c.customer+'?',
      buttons: [
        {
          text: 'Cancelar',
          handler: () => {
            console.log('Disagree clicked');
          }
        },
        {
          text: 'Si, deseo anular',
          handler: () => {
            let canc = c.origindata;
            canc.status = 1;
            canc.nullby = Params.md5(Params.USER_DATA.email);
            firebase.database().ref('cancellations/'+c.dateformat+'/'+c.customercode).set(canc).then(_ => {
              let toast = this.toastCtrl.create({
                message: 'Se ha anulado la suspensión para '+c.customer,
                duration: 3000
              });
              c.status = 1;
              c.nullby = this.accounts[canc.nullby].name;
              toast.present();
            });
          }
        }
      ]
    });
    confirm.present();

  }

  suspend(){
    this.nav.push(CancellatePage);
  }
}




// WEBPACK FOOTER //
// ./src/pages/cancellations/cancellations.ts